import { AlertTriangle, Info, OctagonAlert } from 'lucide-react';
import type { DeclarationBannerContent, DeclarationBannerLevel } from './types';

const LEVEL_STYLES: Record<DeclarationBannerLevel, { container: string; Icon: typeof Info }> = {
  info: { container: 'tw-bg-blue-50 tw-border-blue-200 tw-text-blue-900', Icon: Info },
  warning: { container: 'tw-bg-amber-100 tw-border-amber-300 tw-text-amber-900', Icon: AlertTriangle },
  critical: { container: 'tw-bg-red-100 tw-border-red-300 tw-text-red-900', Icon: OctagonAlert },
};

/**
 * Rendu du bandeau de l'espace de déclaration. Partagé avec l'aperçu de l'admin,
 * pour que ce que l'admin valide soit exactement ce que le bénéficiaire verra.
 */
export default function DeclarationBannerView({ level, title, message }: DeclarationBannerContent) {
  const { container, Icon } = LEVEL_STYLES[level] ?? LEVEL_STYLES.warning;

  return (
    <div role={level === 'info' ? 'status' : 'alert'} className={`tw-border-b ${container}`}>
      <div className="tw-container tw-mx-auto tw-px-4 tw-py-3 tw-flex tw-items-start tw-gap-3">
        <Icon className="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-mt-0.5" aria-hidden="true" />
        <p className="tw-text-sm tw-m-0 tw-whitespace-pre-line">
          {title && <span className="tw-font-semibold">{title} </span>}
          {message}
        </p>
      </div>
    </div>
  );
}
